const styles = theme => ({
  container: {
    alignItems: 'center',
  },
  textField: {
    marginLeft: 24,
    marginRight: 24,
    width: '75%',
  },
});

export default styles;



// WEBPACK FOOTER //
// ./src/scenes/Login/components/CoreContent/components/Form/styles.js